// extracted by mini-css-extract-plugin
export default {"table":"subscriptions-table_table__OxVj4"};